import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

const AdminLink = () => {
  const { isAdmin } = useAdmin();
  const navigate = useNavigate();

  if (!isAdmin) {
    return null;
  }

  return (
    <button
      onClick={() => navigate('/admin/dashboard')}
      className="flex items-center space-x-2 px-4 py-2 text-green-700 hover:bg-green-50 rounded-lg transition-all"
    >
      <span className="text-lg">⚙️</span>
      <span className="font-medium">Admin Panel</span>
    </button>
  );
};

export default AdminLink; 